module.exports = __webpack_public_path__ + "static/media/trivia-play.c5dde1cd.png";